import { isEmptyOrNil } from '@utils/generic';

export const isNotCurrentPage =
  pagePath =>
  ([, href]) =>
    href !== pagePath;

export const getBreadcrumbs = (crumbs, pagePath) =>
  !isEmptyOrNil(crumbs) ? crumbs.filter(isNotCurrentPage(pagePath)) : [];
